import Divider from './Divider';
export { Divider };
export default Divider;
